
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-promotion",
      function () {
        return require("private-next-pages/service-promotion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-promotion"])
      });
    }
  